var uniqueId = function(prefix) {
    return prefix+'_' + Math.random().toString(36).substr(2, 9);
};

// init

var pixel_callback = function () {
    console.log('pixel_callback');
    trackAPIConversion__PageView(0, pixel_em, pixel_ph);

    if (document.querySelector('body').classList.contains('route-app_products')) {

        // ViewContent

        var pixel_ViewContent__now = Math.floor(Date.now() / 1000);
        var pixel_ViewContent__eventID = uniqueId('ViewContent_');
        trackAPIConversion('ViewContent', pixel_ViewContent__eventID, getCookie('_fbp'), getCookie('_fbc'), pixel_ViewContent__now, pixel_em, pixel_ph);
        if (typeof fbq == 'function') {
            fbq('track', 'ViewContent', {
                content_ids: tracking__viewcontent__ids,
                content_name: tracking__viewcontent__title,
                content_type: tracking__viewcontent__type
            }, {eventID: pixel_ViewContent__eventID});
        }
    }
};